export enum Prefix {
  Mr = 'Mr',
  Mrs = 'Mrs',
  Ms = 'Ms',
  Dr = 'Dr',
  Prof = 'Prof',
}
